export const ErrorFactoryFormData = {
  name: "",
  address: "",
  email: "",
  phone: "",
  status: "",
};
export const ErrorUserFormData = {
  name: "",
  role: "",
  factory: "",
  email: "",
  password: "",

  status: "",
};

export const ErrorProductFormData = {
  name: "",
  quality: "",
  price: "",
  discount_amount: "",
  discount_type: "",
  effect_from: "",
  effect_to: "",
  status: "",
};

export const ErrorVendorFormData = {
  name: "",
  type: "",
  address: "",
  contact_number: "",
  status: "",
};

//quality Error data start

export const ErrorQualityFormData = {
  name: "",

  status: "",
};
//quality Error data end

//Sub Quality Error data start

export const ErrorSubQualityFormData = {
  name: "",
  quality: "",
  status: "",
};

//Sub Quality Error data end

//labour cost inital data start
export const ErrorLabourCostFormData = {
  jobtitle: "",
  numberofstaff: "",
  factory: "",
  averagecost: "",
  total: "",
  effectdate: "",
};

//operator Error data end

export const ErrorOperatorCostFormData = {
  name: "",
  factory: "",
  contact_number: "",
  status: "",
  address: "",
};

//operator Error data end

//leafWareHouse Error data data end

export const ErrorLeafWareHouseFormData = {
  name: "",
  address: "",
  contact_number: "",
  status: "",
};

//leafWareHouse Error data data end//quality initial data start

//quality initial data end
//CartoonType error data end

export const ErrorCartoonTypeFormData = {
  name: "",
  size: "",
  product: "",
  product_quantity_per_cartoon: "",
  status: "",
};

//CartoonType initial data end
//PlasticType error data end

export const ErrorPlasticTypeFormData = {
  name: "",
  weight_of_plastic_per_pack: "",
  product: "",
  product_quantity_per_plastic: "",
  weight_of_plastic_per_pices: "",
  type: "",
  status: "",
};

//PlasticType error data end
export const ErrorProductionFormData = {
  name: "",
  quality: "",
  price: "",
  discount_amount: "",
  discount_type: "",
  effect_from: "",
  effect_to: "",
  status: "",
};
//mold error data end

export const ErrorMoldFormData = {
  name: "",
  product: "",
  status: "",
};

//Mold error data end

export const ErrorCartoonStockFormData = {
  purchase_date: "",
  bill_number: "",
  vendor: "",
  cartoon_type: "",
  quantity: "",
  price_per_cartoon: "",
  paid_amount: "",

  total_amount: "",
};
export const ErrorCartoonWithDrawFormData = {
  product_id: "",
  product_qty: "",
  cartoon_qty: "",
  product_quality: "",
  production_date: "",
};

export const ErrorPlasticWithDrawFormData = {
  product_id: "",
  product_qty: "",
  plastic_qty: "",
  product_quality: "",
  production_date: "",
};
export const ErrorPlasticStockFormData = {
  purchase_date: "",
  bill_number: "",
  vendor: "",
  plastic_type: "",
  quantity: "",
  price_per_plastic: "",
  paid_amount: "",
  total_amount: "",
};

export const ErrorLeafStockFormData = {
  purchase_date: "",
  bill_number: "",
  buy_method: "",
  vendor: "",
  leaf_store_ware_house: "",
  quantity: "",
  total_cost_leaf: "",
  paid_amount: "",
  total_cost_leaf_amount: "",
};

export const ErrorStickerStockFormData = {
  bill_number: "",

  vendor_id: "",

  quantity: "",

  paid_amount: "",
  total_amount: "",
};
